import React from 'react';

const Projects = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Projects</h1>
        <p className="text-muted-foreground">Manage all projects</p>
      </div>
      <div className="flex h-[400px] items-center justify-center rounded-lg border border-dashed border-border bg-card">
        <p className="text-muted-foreground">Projects page coming soon...</p>
      </div>
    </div>
  );
};

export default Projects;

